module.exports = require('./dist/jstz.js');
